import Constants from '../constants/Constants';
import _ from 'lodash';

const getDateAndTime = (date) => {
  return date.toISOString();
};

const getAwardYear = (year) => {
  return `${year}-${parseInt(year) + 1}`;
};

const getCurrentUrl = () => {
  const protocol = window.location.protocol;
  const host = window.location.hostname;
  return `${protocol}//${host}`;
};

//if academic year is whitelisted, convert into calendar year
//else return year as is
const checkDualYearFormat = (year) => {
  if(!_.includes(Constants.ACADEMIC_YEAR_WHITELIST, year.toString())){

    return parseInt(year);
  }
  else{

    return parseInt(`${Constants.YEAR_PREFIX}${year.toString().substring(0,2)}`);
  }
}

const formatedYear = (year) => {
  return (year > Constants.CUTOFF_ACADEMICYEAR)?
        `${Constants.YEAR_PREFIX.concat('', year.toString().slice(0, 2))}-${Number(Constants.YEAR_PREFIX.concat('', year.toString().slice(0, 2))) + 1}`: 
        `${year}-${Number(year) + 1}`
};

export default {
  getDateAndTime,
  getAwardYear,
  getCurrentUrl,
  formatedYear,
  checkDualYearFormat
};
